import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { observeSpecimen } from '../../hooks/useGoogleFonts'
import { familyInfo, stackFor } from '../../render/fonts'
import styles from './PropertiesPanel.module.scss'

interface FontSpecimenProps {
  family: string
}

/**
 * One family, written in itself.
 *
 * It asks for its own face the first time it is scrolled into view, which is
 * what lets the list hold all 1818 families without fetching a font file for
 * every one of them. Until then it is drawn in the fallback for its category,
 * and the swap happens on its own when the face lands.
 */
function FontSpecimen({ family }: FontSpecimenProps) {
  const { t } = useTranslation()
  const ref = useRef<HTMLSpanElement>(null)

  useEffect(() => observeSpecimen(ref.current, family), [family])

  return (
    <span className={styles.fontSpecimen} ref={ref}>
      <span
        className={styles.fontOptionName}
        style={{ fontFamily: stackFor(family) }}
      >
        {family}
      </span>
      {/*
        Around one family in six has no `latin-ext`, so every ą, ł and ż in it
        is drawn by the fallback face instead. The whole catalogue is offered
        anyway, but not silently: that is a thing to know before choosing, not
        after publishing.
      */}
      {familyInfo(family)?.polish === false && (
        <span className={`label-small ${styles.fontWarning}`}>
          {t('WEBSITE.FONTS.NO_POLISH')}
        </span>
      )}
    </span>
  )
}

export default FontSpecimen
